<!-- 实例节点 -->
<template>
    <div v-if="componentsData.type == 16">
        <div class="overflow-hidden"
            :style="`border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`"
        >
            <div class="fw-bold"
                :style="`
                    background: ${componentsData.content.title_bg_color}; font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};
                    padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px 5px ${componentsData.content.marginData.left}px;
                `"
            >
                产品节点
            </div>
            <div
                :style="`
                    background: ${componentsData.content.text_bg_color}; font-size: ${componentsData.content.text_size}px; color: ${componentsData.content.text_color};
                    padding: 5px ${componentsData.content.marginData.left}px ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;
                `"
            >
                <div>
                    <div class="dis-flex">
                        <div class="ta-r">
                            <div class="mb-6">节点名称</div> <div>2025.01.01</div> <div>安徽</div>
                        </div>
                        <div class="flex-c flex-col ml-6" v-if="componentsData.content.mode_id == 1">
                            <div class="w10" :style="`border: 2px solid ${componentsData.content.circle_color};`"></div>
                            <div class="txt" :style="`background: ${componentsData.content.line_color};`"></div>
                        </div>
                        <div class="flex-c flex-col ml-6" v-if="componentsData.content.mode_id == 2">
                            <div class="flex-1" :style="`border-left: 2px dashed ${componentsData.content.line_color};`"></div>
                        </div>
                        <div class="flex-c flex-col ml-6" v-if="componentsData.content.mode_id == 3">
                            <div class="txt" :style="`background: ${componentsData.content.line_color};`"></div>
                        </div>
                        <div class="ta-l ml-6">
                            <div>节点内容节点内容节点内容节点内容节容节点内容节点内容节点内容节点内容</div>
                            <div class="content-div"></div>
                            <div class="content-div"></div>
                        </div>
                    </div>
                    <div class="dis-flex">
                        <div class="ta-r">
                            <div class="mb-6">节点名称</div> <div>2025.01.01</div> <div>安徽</div>
                        </div>
                        <div class="flex-c flex-col ml-6" v-if="componentsData.content.mode_id == 1">
                            <div class="w10" :style="`border: 2px solid ${componentsData.content.circle_color};`"></div>
                            <div class="txt" :style="`background: ${componentsData.content.line_color};`"></div>
                        </div>
                        <div class="flex-c flex-col ml-6" v-if="componentsData.content.mode_id == 2">
                            <div class="flex-1" :style="`border-left: 2px dashed ${componentsData.content.line_color};`"></div>
                        </div>
                        <div class="flex-c flex-col ml-6" v-if="componentsData.content.mode_id == 3">
                            <div class="txt" :style="`background: ${componentsData.content.line_color};`"></div>
                        </div>
                        <div class="ta-l ml-6">
                            <div>节点内容节点内容节点内容节点内容节容节点内容节点内容节点内容节点内容</div>
                            <div class="content-div"></div>
                            <div class="content-div"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
}
.dis-flex {
    display: flex;
}
.mb-6 {
    margin: 0 0 6px 0;
}
.mr-6 {
    margin: 0 6px 0 0;
}
.ml-6 {
    margin: 0 0 0 6px;
}
.w10 {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}
.txt {
    width: 2px;
    border-radius: 1px;
    flex: 1;
}
.flex-1 {
    flex: 1;
}
.content-div {
    margin: 6px 0 0 0;
    width: 60px;
    height: 60px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    background: #efefef;
}
</style>